import {
    CalendarDay,
    getDayNameFromLabel,
    PrayerHour,
} from "../calendar/utils";
import { Settings } from "../utils/settings";
import { LiturgyItem } from "./types";
export const getProperCollect = (
    day: CalendarDay,
    hour: PrayerHour,
    optional: boolean,
    settings: Settings
) => {
    const actualDay = day.eveOf && hour !== "mattins" ? day.eveOf : day;

    const result: LiturgyItem[] = [];

    if (!optional) {
        result.push({
            type: "rubric",
            content: `The Officiant shall say or sing the\\n**Collect${
                day.collectId === "good-friday" ? "s" : ""
            } for ${
                day.label === "holy-saturday" && hour !== "mattins"
                    ? "Easter Eve"
                    : getDayNameFromLabel(actualDay.collectId)
            },**`,
            settingsPanelId: "collect",
        });
    }

    result.push({
        type: "text",
        content: `${
            day.label === "holy-saturday" && hour !== "mattins"
                ? "Grant, O Lord, that as we are baptized into the death of thy blessed Son our Saviour Jesus Christ, so by continual mortifying our corrupt affections we may be buried with him; and that, through the grave, and gate of death, we may pass to our joyful resurrection; for his merits, who died, and was buried, and rose again for us, thy Son Jesus Christ our Lord."
                : actualDay.collect
        } **Amen.**`,
    });

    if (day.collectId === "good-friday") {
        result.push({
            type: "text",
            content: `Almighty and everlasting God, by whose Spirit the whole body of the Church is governed and sanctified: Receive our supplications and prayers, which we offer before thee for all estates of men in thy holy Church, that every member of the same, in his vocation and ministry, may truly and godly serve thee; through our Lord and Saviour Jesus Christ. **Amen.**`,
        });
        result.push({
            type: "text",
            content: `O merciful God, who hast made all men, and hatest nothing that thou hast made, nor wouldest the death of a sinner, but rather that he should be converted and live: Have mercy upon all Jews, Turks, Infidels, and Hereticks, and take from them all ignorance, hardness of heart, and contempt of thy word; and so fetch them home, blessed Lord, to thy flock, that they may be saved among the remnant of the true Israelites, and be made one fold under one shepherd, Jesus Christ our Lord, who liveth and reigneth with thee and the Holy Spirit, one God, world without end. **Amen.**`,
        });
    }

    if (
        settings.adventAndLentCollects === "repeat" &&
        (day.collectId.includes("lent-") || day.collectId === "good-friday")
    ) {
        if (!optional) {
            result.push({
                type: "rubric",
                content: "The **Collect for Ash Wednesday** throughout_Lent,",
            });
        }

        result.push({
            type: "text",
            content: `Almighty and everlasting God, who hatest nothing that
                thou hast made and dost forgive the sins of all them
                that are penitent: Create and make in us new and
                contrite hearts, that we, worthily lamenting our sins,
                and acknowledging our wretchedness, may obtain of thee,
                the God of all mercy, perfect remission and forgiveness;
                through Jesus Christ our Lord. **Amen.**`,
        });
    }

    if (
        settings.adventAndLentCollects === "repeat" &&
        day.collectId.includes("advent") &&
        !day.collectId.includes("advent-1") &&
        day.collectId !== "sunday-before-advent"
    ) {
        if (!optional) {
            result.push({
                type: "rubric",
                content:
                    "The **Collect for The First Sunday in Advent** throughout_Advent,",
            });
        }

        result.push({
            type: "text",
            content: `Almighty God, give us grace that we may cast away the
                works of darkness, and put upon us the armour of light,
                now in the time of this mortal life in which thy Son
                Jesus Christ came to visit us in great humility; that in
                the last day, when he shall come again in his glorious
                majesty to judge both the quick and the dead, we may
                rise to the life immortal; through him who liveth and
                reigneth with thee and the Holy Ghost, one God, now and
                for ever. **Amen.**`,
        });
    }

    return result;
};
